module.exports = __webpack_public_path__ + "static/media/forest.e0aab3c7.webp";